import { render, staticRenderFns } from "./TransferTicket.vue?vue&type=template&id=774fdd4e&scoped=true&"
import script from "./TransferTicket.vue?vue&type=script&lang=js&"
export * from "./TransferTicket.vue?vue&type=script&lang=js&"
import style0 from "./TransferTicket.vue?vue&type=style&index=0&id=774fdd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774fdd4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
